import React, { type ReactNode } from 'react';
import { FormattedDate } from 'react-intl';
import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { cssTheme } from '@daedalus/atlas/themes';
import { TimelineConnector } from './TimelineConnector';
import { TimelineDot } from './TimelineDot';
type Props = {
  topComponent: ReactNode;
  bottomComponent: ReactNode;
  middleComponent: ReactNode;
  customGap?: boolean;
  dates?: [string, string, string];
};
const _exp = /*#__PURE__*/() => Flex.Column;
const _exp2 = /*#__PURE__*/() => ({
  placement
}) => placement === 'center' ? '-3px' : cssTheme.layout.spacing.s000;
const SeparatorGrid = /*#__PURE__*/styled(_exp())({
  name: "SeparatorGrid",
  class: "s14wabob",
  propsAsIs: true,
  vars: {
    "s14wabob-0": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => Icon;
const TransitionIcon = /*#__PURE__*/styled(_exp3())({
  name: "TransitionIcon",
  class: "t15k3pse",
  propsAsIs: true
});
const _exp4 = /*#__PURE__*/() => Flex.Column;
const DateWrapper = /*#__PURE__*/styled(_exp4())({
  name: "DateWrapper",
  class: "dkb2pye",
  propsAsIs: true
});
const TimelineRow = ({
  component,
  placement
}: {
  component: ReactNode;
  placement: 'top' | 'center' | 'bottom';
}) => <Grid container spacing="s000" wrap="nowrap" gap="s400">
    <SeparatorGrid alignItems="center" justifyContent="center" gap="s200" placement={placement}>
      {placement === 'top' && <>
          <TimelineDot />
          <TimelineConnector />
        </>}
      {placement === 'center' && <>
          <TimelineConnector type="dashed" />
          <TransitionIcon name="Refresh3" size="sm" colorPath="content.accent.c500" />
          <TimelineConnector type="dashed" />
        </>}
      {placement === 'bottom' && <>
          <TimelineConnector />
          <TimelineDot />
        </>}
    </SeparatorGrid>
    {component}
  </Grid>;
export const SplitBookingTimeline = ({
  topComponent,
  middleComponent,
  bottomComponent,
  customGap = false,
  dates
}: Props) => <ContentWrapper paddingTop={customGap ? 's000' : 's250'}>
    <Flex.Row gap="s300">
      {dates && <DateWrapper justifyContent="space-between">
          {dates.map(date => <Text variant="labelS" key={date}>
              <FormattedDate value={date} day="numeric" month="short" timeZone="UTC" />
            </Text>)}
        </DateWrapper>}
      <Grid container spacing="s000" gap={customGap ? 's000' : 's400'}>
        <TimelineRow placement="top" component={topComponent} />
        <TimelineRow placement="center" component={middleComponent} />
        <TimelineRow placement="bottom" component={bottomComponent} />
      </Grid>
    </Flex.Row>
  </ContentWrapper>;

require("./SplitBookingTimeline.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SplitBookingTimeline.tsx");